var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStorygameItem = function SvgIconStorygameItem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.5 8.5-4-6h-4m8 6c-3 8.5-10 12.5-10 12.5m10-12.5-6 1m-4 11.5s-7-4-10-12.5m10 12.5-4-11.5m4 11.5 4-11.5m-14-1 4-6h4m-8 6 6 1m2-7h4m-4 0-2 7m6-7 2 7m-8 0h8",
    stroke: "#fff",
    strokeOpacity: "current",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
};
export default SvgIconStorygameItem;